import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Building2Icon, HammerIcon, KeyIcon, ArrowRightIcon } from 'lucide-react';
export function ProjectAreas() {
  const areas = [{
    title: 'Neubau',
    subtitle: 'Energieeffizient von Anfang an',
    description: 'Bei einem Neubau werden die wichtigsten Weichen bereits in der Planungsphase gestellt. Ich begleite Sie von der ersten Konzeptidee über die Wahl des Effizienzhaus-Standards bis zur Fachplanung – damit Ihr Gebäude langfristig komfortabel, wertstabil und gut förderfähig ist.',
    points: ['Effizienzhaus-Konzeption (KfW)', 'Energetische Fachplanung', 'Baubegleitung und Qualitätssicherung'],
    icon: Building2Icon
  }, {
    title: 'Sanierung',
    subtitle: 'Bestand klug weiterentwickeln',
    description: 'Sanierung ist mein Schwerpunkt. Gemeinsam analysieren wir, welche Maßnahmen für Ihr Gebäude wirklich sinnvoll sind – einzeln oder als Teil eines individuellen Sanierungsfahrplans (iSFP). So vermeiden Sie Fehlinvestitionen und nutzen Fördermittel optimal aus.',
    points: ['Individueller Sanierungsfahrplan (iSFP)', 'Einzelmaßnahmen mit BAFA-Förderung', 'Komplettsanierung zum Effizienzhaus'],
    icon: HammerIcon
  }, {
    title: 'Vermietung & Verkauf',
    subtitle: 'Klarheit für Ihre Immobilie',
    description: 'Wer vermietet oder verkauft, braucht belastbare energetische Kennwerte – und im Idealfall eine Einschätzung möglicher Sanierungspotenziale. Ich erstelle die gesetzlich erforderlichen Energieausweise und unterstütze Eigentümer wie Kaufinteressenten bei der Bewertung.',
    points: ['Bedarfs- und Verbrauchsausweise', 'Energetische Kaufberatung', 'Bewertung von Sanierungspotenzialen'],
    icon: KeyIcon
  }];
  const container = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7
      }
    }
  };
  return <section id="projektphasen" className="py-24 md:py-32 bg-secondary" data-id="element-316">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-317">
        <div className="max-w-3xl mb-20" data-id="element-318">
          <span className="text-primary font-medium tracking-widest uppercase text-sm mb-6 block" data-id="element-319">
            Was planen Sie?
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-accent mb-6 leading-tight" data-id="element-320">
            Drei Wege, wie ich Sie begleite
          </h2>
          <p className="text-lg text-accent/70 font-light" data-id="element-321">
            Ob Sie neu bauen, ein Bestandsgebäude weiterentwickeln oder eine
            Immobilie übergeben möchten – ich begleite Sie in der jeweils
            passenden Tiefe. Wählen Sie die Phase, die zu Ihrem Vorhaben passt.
          </p>
        </div>

        <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid md:grid-cols-3 gap-6 lg:gap-8" data-id="element-322">
          {areas.map((area, index) => <motion.article key={index} variants={item} className="group relative bg-white rounded-2xl p-8 md:p-10 border border-accent/5 hover:border-primary/30 transition-all duration-500 flex flex-col" data-id="element-323">
              <div className="flex items-start justify-between mb-8" data-id="element-324">
                <span className="text-xs font-medium tracking-widest text-accent/40 uppercase" data-id="element-325">
                  0{index + 1}
                </span>
                <div className="w-12 h-12 rounded-full bg-sage flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors duration-500" data-id="element-326">
                  <area.icon size={20} strokeWidth={1.5} data-id="element-327" />
                </div>
              </div>

              <h3 className="text-2xl md:text-3xl font-serif text-accent mb-2 leading-tight h-16 md:h-20 flex items-start" data-id="element-328">
                {area.title}
              </h3>
              <p className="text-primary text-sm font-medium mb-6 h-10 flex items-start" data-id="element-329">
                {area.subtitle}
              </p>

              <p className="text-accent/70 font-light leading-relaxed mb-8 min-h-[11rem] lg:min-h-[13rem]" data-id="element-330">
                {area.description}
              </p>

              <ul className="space-y-3 mb-8 pt-6 border-t border-accent/10 mt-auto" data-id="element-331">
                {area.points.map((point, i) => <li key={i} className="flex items-start text-sm text-accent/80" data-id="element-332">
                    <span className="text-primary mr-3 mt-0.5" data-id="element-333">―</span>
                    <span data-id="element-334">{point}</span>
                  </li>)}
              </ul>

              <a href="#kontakt" className="mt-auto inline-flex items-center text-sm font-medium text-accent group-hover:text-primary transition-colors" data-id="element-335">
                Beratung anfragen
                <ArrowRightIcon size={16} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-336" />
              </a>
            </motion.article>)}
        </motion.div>
      </div>
    </section>;
}